import styled from "@emotion/styled";

export const SectionContainer = styled.section(() => ({
  display: "flex",
  flexDirection: "column",
  paddingRight: "1.5rem",
  paddingLeft: "1.5rem",
  backgroundRepeat: "no-repeat",
}));
